module.exports = __webpack_public_path__ + "static/media/fdrpLogo.0a9076ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdrpLogo.png
// module id = 1054
// module chunks = 0